import { render, staticRenderFns } from "./GiftCardNetworkSettings.vue?vue&type=template&id=23bb3b9f&"
import script from "./GiftCardNetworkSettings.vue?vue&type=script&lang=ts&"
export * from "./GiftCardNetworkSettings.vue?vue&type=script&lang=ts&"
import style0 from "./GiftCardNetworkSettings.vue?vue&type=style&index=0&id=23bb3b9f&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports